import React from "react"
import ReactDOM from "react-dom"
import TimelineContainer from "./timeline-container-component"

export default class TimelineContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<TimelineContainer {...self.modelJson} />, self.elem)
  }
}
